/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .kt-loading-bar{position:absolute;top:0;left:0;right:0;width:100%}[_nghost-%COMP%]     .kt-loading-bar .progress-bar{background-color:#5d78ff}[_nghost-%COMP%]     .kt-header__topbar-item{height:100%}@media (min-width:1025px){[_nghost-%COMP%]     .kt-header__topbar, [_nghost-%COMP%]     .kt-header__topbar-item-wrapper{height:100%}}"];
export { styles as styles };
